/* terminal/actions */
import { action } from "typesafe-actions";
import { Terminal, TerminalActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: (err: string | null, data: Terminal | null) => unknown | null
) => action(TerminalActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Terminal) =>
  action(TerminalActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(TerminalActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Terminal | null) => unknown
) => action(TerminalActionTypes.SAVE_REQUEST, { data, callback });

export const saveBulk = (
  data: Data,
  callback?: (err: string | null, data: Terminal | null) => unknown
) => action(TerminalActionTypes.SAVE_BULK, { data, callback });

export const saveSuccess = (data: Terminal) =>
  action(TerminalActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(TerminalActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(TerminalActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(TerminalActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(TerminalActionTypes.DELETE_ERROR, error);

export const uploadFile = (
  data: string,
  callback?: (err: string | null, data: any | null) => unknown
) => action(TerminalActionTypes.UPLOAD_FILE, { data, callback });

export const uploadFileSuccess = (data: any) =>
  action(TerminalActionTypes.UPLOAD_FILE_SUCCESS, data);

export const uploadFileError = (error: string) =>
  action(TerminalActionTypes.UPLOAD_FILE_ERROR, error);

export const updateState = (data: Data[]) =>
  action(TerminalActionTypes.UPDATE_STATE, data);

export const downloadRequest = (
  params: {
    header?: string[],
    excludeFields?: string[]
  },
  callback?: (err?: string | null, data?: any | null) => unknown
) => action(TerminalActionTypes.DOWNLOAD_REQUEST, { params, callback });
